const AVATAR_COLORS = [
  '#7c3aed', '#2563eb', '#059669', '#d97706',
  '#dc2626', '#0891b2', '#9333ea', '#db2777',
];

export function hashColor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = (hash * 31 + name.charCodeAt(i)) & 0x7fffffff;
  }
  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
}

export function getInitials(name: string): string {
  return name
    .split(' ')
    .slice(0, 2)
    .map(w => w[0]?.toUpperCase() ?? '')
    .join('');
}

export function parseViewParams() {
  const params = new URLSearchParams(window.location.search);
  return {
    view: params.get('view'),
    activate: params.get('activate'),
    delete: params.get('delete'),
  };
}

export function getAdminSecret(): string | null {
  const match = window.location.pathname.match(/^\/admin\/(.+)$/);
  return match ? match[1] : null;
}
